import Vue from "vue";
import Vuetify from "vuetify/lib";
import store from "@/store";

Vue.use(Vuetify);

export default new Vuetify({
  rtl: store.getters.language === "ar",
  icons: {
    iconfont: "mdi"
  },
  theme: {
    themes: {
      light: {
        accent: "#82B1F2",
        primary: "#71a949",
        secondary: "#424242",
        error: "#FF5252",
        info: "#2196F3",
        success: "#4CAF50",
        warning: "#FFC107"
      }
    }
  }
});
